// extracted by mini-css-extract-plugin
export default {"modal_controller":"PageWrapper_modal_controller__+YWLl","warning_header":"PageWrapper_warning_header__VvUko"};